import styled from 'styled-components';

export const Flex = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
`;
